import styled from 'styled-components';

const HiddenFooterContainer = styled.div`
  display: flex;
  justify-content: center;
  visibility: hidden;
`;

export default HiddenFooterContainer;
